import { useTranslation } from 'i18n';
import { ToggleButton, ToggleButtonGroup } from 'ui';

import { CompanySourceEnum, type CompanySourceType } from '../../enums';

type Props = {
  onTradeCompanyTypeChange: (tradeCompanyType: CompanySourceType) => void;
  tradeCompanyType: CompanySourceType;
};

export const CompanySourceToggleButton = ({ tradeCompanyType, onTradeCompanyTypeChange }: Props) => {
  const { t } = useTranslation('orders');

  return (
    <ToggleButtonGroup
      value={tradeCompanyType}
      exclusive
      onChange={(_, newTradeCompanyType) => onTradeCompanyTypeChange(newTradeCompanyType)}
      fullWidth
    >
      <ToggleButton value={CompanySourceEnum.GROUND_CONTROL} color="primary">
        {t('tradeSignals.companySourceToggleButton.options.groundControlCompany')}
      </ToggleButton>
      <ToggleButton value={CompanySourceEnum.HUBSPOT} color="primary">
        {t('tradeSignals.companySourceToggleButton.options.hubspotLead')}
      </ToggleButton>
    </ToggleButtonGroup>
  );
};
